import { IPermission } from "./tenant";

export interface IGroupModule extends IPermission {
  id: number;
  moduleName: string;
  subModules: null;
}

export interface IGroupSubModule extends IPermission {
  isDefault: boolean;
  moduleID: number;
  subModuleID: number;
  subModuleName: string;
}

export interface IGroupPermission extends IPermission {
  subModuleID: string
}

export interface IGroupPractitioner extends IPermission {
  email: string;
  firstname: string;
  gender: string;
  groups: null;
  id: string;
  lastname: string;
  status: number;
}

export interface IGroup {
  id: number;
  groupName: string;
  createdAt: string;
  updatedAt?: string;
  modules?: IGroupModule[];
  subModules?: IGroupSubModule[];
  permissions?: IGroupPermission[];
  practitioners?: IGroupPractitioner[];
}

export interface ICreateGroupPayload {
  GroupName: string;
  PermissionID: number[];
}

export interface IEditGroupNamePayload {
  GroupName: string;
}

export interface IDeleteGroupPayload {
  id: number;
  groupName: string;
}

export interface IAddGroupPermissionsPayload {
  groupID: number;
  permissionID: number[];
}

export interface IRemoveGroupPermissionsPayload {
  groupID: number;
  permissionID: number[];
}

export interface ISubModulePermissions {
  subModuleID: number;
  permissionID: number;
  permissionName: string;
}

// ENUMS
export enum GroupAction {
  CREATE = "create",
  READ = "read",
  UPDATE = "update",
  DELETE = "delete",
}